import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';

import { VersionDialogModule } from './../version-dialog/version-dialog.module';
import { CleaningDialogModule } from '../cleaning-dialog/cleaning-dialog.module';
import { SlaTopbarComponent } from './sla-topbar.component';

export * from './sla-topbar.component';

@NgModule({
    declarations: [
        SlaTopbarComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        MatToolbarModule,
        MatIconModule,
        MatDividerModule,
        MatMenuModule,
        MatButtonModule,
        MatProgressBarModule,
        MatDialogModule,
        VersionDialogModule,
        CleaningDialogModule,
    ],
    exports: [
        SlaTopbarComponent,
    ],
})
export class SlaTopbarModule { }
